import '../fesd/fesd'
import '../../sass/investor/investor_company.sass'
import { _dropdown } from '../includes/_dropdown.js'

$(function(){
  _dropdown.all();
  _dropdown.deskDropdown();
  $('[data-tab-container]').tab4();
});